import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {TabCountsResult} from "../payload-types/tab-counts";

/**
 * API-Interface für die Startseiten-Tab-Trefferzahlen (POST {@link RevaApi.PATH_VALUATIONS_TAB_COUNTS}).
 * Schickt den aktuellen Freitextfilter und liefert je für den User sichtbarem Tab eine Trefferzahl,
 * plus die eigenen/alle Snapshot-Zahlen. Grundlage der gelben Tab-Badges, die bei aktivem
 * Live-Freitextfilter erscheinen. Ein optionales {@link AbortSignal} erlaubt es einem neueren
 * Tastendruck, die vorherige noch laufende Count-Anfrage abzubrechen.
 */
export class TabCountsApiInterface extends SimpleApiInterface<TabCountsResult> {
    constructor(
        private readonly filterFreeText: string | null,
        private readonly signal?: AbortSignal,
    ) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS_TAB_COUNTS]);
    }

    protected buildPayload(): Record<string, unknown> {
        return {
            filterFreeText: this.filterFreeText ?? undefined,
        };
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<TabCountsResult> {
        return executor.fetchPOST(url, credentials, this.buildPayload(), this.signal);
    }
}
